import { Link } from "react-router-dom";

import { Button } from "../components/ui/button";

export function NotFoundPage() {
  return (
    <div className="glass-panel mx-auto max-w-xl px-6 py-16 text-center">
      <p className="text-sm font-semibold uppercase tracking-[0.24em] text-muted-foreground">404</p>
      <h1 className="mt-4 font-display text-4xl font-semibold">That page has gone off-menu.</h1>
      <p className="mt-4 text-muted-foreground">
        Head back to the catalogue to browse platters and continue ordering.
      </p>
      <Link className="mt-8 inline-flex" to="/">
        <Button size="lg">Return home</Button>
      </Link>
    </div>
  );
}
